var exports = {
  "S": "x234b8571--bc6007--image",
  "w": "x234b8571--bc6007--image-icon",
};

module.exports = exports;
